import { get } from './apiUtil';
import { AxiosResponse } from 'axios';
import { ReportData } from '../model/reportData';

export function getIncompleteEvents(query: string): Promise<ReportData[]> {
  return new Promise((resolve, reject) => {
    get(`/api/eaus/v1/events/incompleteEvents` + query)
      .then((response: AxiosResponse) => resolve(response.data as ReportData[]))
      .catch((e) => reject(e));
  });
}

export function getPictureDayConnectionDetails(query: string): Promise<ReportData[]> {
  return new Promise((resolve, reject) => {
    get(`/api/eaus/v1/events/pictureDayConnectionDetails` + query)
      .then((response: AxiosResponse) => resolve(response.data as ReportData[]))
      .catch((e) => reject(e));
  });
}

export function getTodayEmCompleteDetails(query: string): Promise<ReportData[]> {
  return new Promise((resolve, reject) => {
    get(`/api/eaus/v1/events/todayEventCompleteDetails` + query)
      .then((response: AxiosResponse) => resolve(response.data as ReportData[]))
      .catch((e) => reject(e));
  });
}

export function getNotUploadedEvents(query: string): Promise<ReportData[]> {
  return new Promise((resolve, reject) => {
    get(`/api/eaus/v1/events/notUploadedEvents` + query)
      .then((response: AxiosResponse) => resolve(response.data as ReportData[]))
      .catch((e) => reject(e));
  });
}

export function getQuarantineEvents(query: string): Promise<ReportData[]> {
  return new Promise((resolve, reject) => {
    get(`/api/eaus/v1/events/quarantineEvents` + query)
      .then((response: AxiosResponse) => resolve(response.data as ReportData[]))
      .catch((e) => reject(e));
  });
}